module.exports = __webpack_public_path__ + "static/media/image_4.7f99d5fc.png";